import React from "react";
import { FiAlertTriangle } from "react-icons/fi";
import classes from "./AreYouSure.module.css";

export default function AreYouSure({
  open,
  title = "Are you sure?",
  message = "This action cannot be undone.",
  confirmText = "Confirm",
  cancelText = "Cancel",
  loading = false,
  danger = true,
  onConfirm,
  onClose,
}) {
  if (!open) return null;

  return (
    <div className={classes.overlay} onMouseDown={onClose}>
      <div className={classes.modal} onMouseDown={(e) => e.stopPropagation()}>
        <div className={classes.iconWrap}>
          <FiAlertTriangle />
        </div>
        <h3>{title}</h3>
        <p>{message}</p>
        <div className={classes.actions}>
          <button type="button" className="btnBase btnSecondary" onClick={onClose}>
            {cancelText}
          </button>
          <button
            type="button"
            className={`btnBase ${danger ? "btnDanger" : "btnPrimary"}`}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? "Please wait..." : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
